<!-- 分页 -->
<template>
	<div class="page" v-if="total > 0">
		<el-pagination background layout="slot" :total="total" :page-size="pageSize">
			<div class="slot first-pager" @click="jumpPage('1')">首页</div>
		</el-pagination>
		<el-pagination background layout="prev, pager, next, slot" :total="total" :page-size="pageSize"
			:current-page="page" @current-change="clickPage">
			<div class="slot last-pager" @click="jumpPage('0')">尾页</div>
		</el-pagination>
	</div>
</template>

<script>
	export default {
		name: 'Pagination',
		props: {
			total: {
				type: Number,
				default: 0
			},
			page: {
				type: Number,
				default: 1
			},
			pageSize: {
				type: Number,
				default: 20
			}
		},
		data() {
			return {}
		},
		watch: {
			page(newVal) {
				return newVal
			}
		},
		methods: {
			jumpPage(val) {
				switch (val) {
					case "1": //跳转到首页
						this.$emit('currentPage', 1);
						break;
					case "0": //跳转到末页
						this.$emit('currentPage', Math.ceil(this.total / this.pageSize));
						break;
				}
			},
			clickPage(i) {
				this.$emit('currentPage', i);
			}
		}
	}
</script>
<style scoped>
	.slot {
		vertical-align: top;
		display: inline-block;
		background: #fff;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		text-align: center;
		cursor: pointer;
		margin: 0 5px;
		background-color: #f4f4f5;
		color: #606266;
		min-width: 30px;
		border-radius: 2px;
		padding: 0 4px;
		font-size: 13px;
		height: 28px;
		line-height: 28px;
	}

	.slot:hover {
		background-color: #409EFF;
		color: #FFF;
	}

	.last-pager {
		margin-left: 10px;
	}

	/* 分页器 */
	.page {
		text-align: center;
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue